import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="mobile_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
      return;
    }
    if (formData.message.length > 500) {
      setStatus('error');
      setErrorMsg('留言内容不能超过500个字符');
      return;
    }
    const payload = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9q556knlsngrm4llrog', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = { code: 'Unknown' }; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请稍后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
              如果您有任何疑问、合作意向或批发采购需求，欢迎通过以下方式联系我们，或填写右侧表单，我们将在24小时内与您取得联系。
            </p>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">客服电话</p>
                  <p className="text-sm text-foreground-500">400-888-6666</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-accent-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                  <p className="text-sm text-foreground-500">service@bocaicandy.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-secondary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">公司地址</p>
                  <p className="text-sm text-foreground-500">广东省广州市天河区珠江新城华夏路88号</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center shrink-0">
                  <i className="ri-time-line text-foreground-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">工作时间</p>
                  <p className="text-sm text-foreground-500">周一至周日 9:00 - 21:00</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="bg-background-100 rounded-lg p-6" data-readdy-form="">
              <input
                type="text"
                name="mobile_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <h3 className="text-lg font-heading text-foreground-900 mb-5">在线留言</h3>
              <div className="space-y-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    您的姓名 <span className="text-secondary-500">*</span>
                  </label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    电子邮箱 <span className="text-secondary-500">*</span>
                  </label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="contact-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    联系电话
                  </label>
                  <input
                    id="contact-phone"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的电话"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-secondary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您想咨询的内容（500字以内）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">{formData.message.length}/500</p>
                </div>
                <button
                  type="submit"
                  className="w-full py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交留言
                </button>
                {status === 'success' && (
                  <p className="text-sm text-green-600 text-center">提交成功！我们会尽快与您联系</p>
                )}
                {status === 'error' && (
                  <p className="text-sm text-red-500 text-center">{errorMsg}</p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}